/**
 * A timecode that can be clicked to type another one and jump there (0.96.0). Enter jumps, Escape or leaving the
 * field keeps the position. Digits are read as on a broadcast keypad ("1000" is 00:00:10:00).
 */
import { useState } from 'react';
import type { Rational } from '@prism/contracts';
import { parseTimecodeEntry } from './timelineTools';

export function TimecodeField({ value, rate, onJump, className, testId, title = 'Click to type a timecode and jump there' }: {
  value: string; rate: Rational; onJump: (ticks: number) => void; className?: string; testId?: string; title?: string;
}) {
  const [editing, setEditing] = useState<string | null>(null);
  const [bad, setBad] = useState(false);
  if (editing === null) {
    return (
      <button type="button" className={`tc-button ${className ?? ''}`} data-testid={testId} title={title} onClick={() => { setEditing(value); setBad(false); }}>
        {value}
      </button>
    );
  }
  const commit = () => {
    const t = parseTimecodeEntry(editing, rate);
    if (t == null) { setBad(true); return; }
    setEditing(null);
    onJump(t);
  };
  return (
    <input
      className={`input mono tc-input ${bad ? 'invalid' : ''} ${className ?? ''}`} autoFocus value={editing} aria-label="Go to timecode" aria-invalid={bad}
      data-testid={testId ? `${testId}-input` : undefined} spellCheck={false}
      onFocus={(e) => e.currentTarget.select()}
      onChange={(e) => { setEditing(e.target.value); setBad(false); }}
      onKeyDown={(e) => {
        e.stopPropagation();
        if (e.key === 'Enter') { e.preventDefault(); commit(); }
        else if (e.key === 'Escape') { e.preventDefault(); setEditing(null); }
      }}
      onBlur={() => setEditing(null)}
    />
  );
}
